// extracted by mini-css-extract-plugin
export default {"sliderBlock":"Slider_sliderBlock__c9duF"};